import { AxiosResponse } from "axios";
import { parseApiMetaFilters } from "PFApp/components/filters_v2";
import { BaseMeta, Snakify } from "PFTypes";

type RawResponseWithFiltersMeta = Record<string, any> & {
  data: {
    meta: Snakify<Pick<BaseMeta<undefined>, "filters" | "defaultFilters" | "target">>;
  };
};

export const parseResponseFilters = (response: AxiosResponse) => {
  if (!response.data?.meta?.filters) {
    return;
  }

  const rawResponse: RawResponseWithFiltersMeta = response;

  response.data.meta.filtersV2 = parseApiMetaFilters(
    rawResponse.data.meta.filters,
    rawResponse.data.meta.target,
    rawResponse.data.meta.default_filters
  );
};
